export default __webpack_public_path__ + "static/img_work_approach-930571151e3bcb4d898e43cd47a6eca3.png";